import { flow, getParent, types } from 'mobx-state-tree';
import { STATUS_TITLES } from '../../constants/orders/status-list';

const { inProcess, stopped } = STATUS_TITLES;

const BASE_URL = 'order/v1/Orders';

export const TableData = types
  .model('TableData', {
    id: types.string,
    systemCode: types.string,
    title: types.string,
    status: types.string,
    shippingStatus: types.string,
    orderPlacedTime: types.string,
    purchaseTime: types.string,
    destinationAccount: types.string,
    destinationOrderNumber: types.maybe(types.string),
    quantity: types.number,
    salePrice: types.number,
    profit: types.number,
    imageUrl: types.string,
    estimatedArrivalDate: types.maybe(types.string),
    buyerEmail: types.maybe(types.string),
    buyerUsername: types.maybe(types.string),
    sourceOrderNumber: types.maybe(types.string),
    failedReason: types.maybe(types.string),
    sourceItemCode: types.maybe(types.string),
    sourceMarketplaceId: types.maybe(types.string),
    sourceMarketplaceName: types.maybe(types.string),
    sourcePrice: types.number,
    destinationItemUrl: types.maybe(types.string),
    destinationItemId: types.maybe(types.string),
    originalTrackingNumber: types.maybe(types.string),
    originalCarrier: types.maybe(types.string),
    destinationMarketplaceId: types.maybe(types.string),
    isBuyItForMe: types.maybe(types.boolean),
    buyerName: types.maybe(types.string),
    globalShippingProgram: types.maybe(types.boolean),
    note: types.maybe(types.string),
    loading: false,
    sourceTrackingUrl: types.maybe(types.string),
    isGlobalOrder: types.maybe(types.boolean),
    // buyer info
    shippingBuyerName: types.maybe(types.string),
    buyerAddressCity: types.maybe(types.string),
    buyerAddressCountry: types.maybe(types.string),
    buyerAddressLine1: types.maybe(types.string),
    buyerAddressLine2: types.maybe(types.string),
    buyerAddressState: types.maybe(types.string),
    buyerAddressZipCode: types.maybe(types.string),
    returnState:types.maybe(types.string),
    lostOrderState:types.maybe(types.string),
  })
  .views(self => ({
    get buyerInfoTitle() {
      return `${self.shippingBuyerName ? `${self.shippingBuyerName}, ` : ''
        }${self.buyerAddressLine1 || ''}`;
    },
    get buyerInfo() {
      let info = '';
      if (self.shippingBuyerName) {
        info += `${self.shippingBuyerName}\n`;
      }
      if (self.buyerAddressLine1) {
        info += `${self.buyerAddressLine1}\n`;
      }
      if (self.buyerAddressLine2) {
        info += `${self.buyerAddressLine2}\n`;
      }
      if (self.buyerAddressCity) {
        info += `${self.buyerAddressCity}\n`;
      }
      if (self.buyerAddressState) {
        info += `${self.buyerAddressState}, `;
      }
      if (self.buyerAddressCountry) {
        info += `${self.buyerAddressCountry}`;
      }
      return info;
    },
  }))
  .actions(self => ({
    updateStatus(status = inProcess) {
      self.status = status;
    },
    stopResumeOrder: flow(function* stopResumeOrder(id, type) {
      try {
        const URL = `${BASE_URL}/${id}/${type}`;
        const { headers } = getParent(self, 2).requestData;
        yield getParent(self, 2).transport5007.update(URL, {}, {}, headers);
        const nextStatus = type === 'stop' ? stopped : inProcess;
        getParent(self, 2).updateSingleAndTableOrderStatus(id, nextStatus);
      } catch (err) {
        console.log(err);
      }
    }),
    requestRefund: flow(function* requestRefund(id) {
      const parentRef = getParent(self, 2);
      try {
        const URL = `${BASE_URL}/refund?orderId=${id}`;
        const {data} = yield parentRef.transport5007.fetch(URL);
        if(data.length>0){
          parentRef.showToast({
            type: parentRef.enums.TOAST_TYPES.WARNING,
            message: data
          });
        }else{
          parentRef.showToast({
            type: parentRef.enums.TOAST_TYPES.INFO,
            message: 'A return request has been submitted for this order',
          });
        }
      } catch (err) {
        console.log(err);
        parentRef.showToast({
          type: parentRef.enums.TOAST_TYPES.WARNING,
          message: 'There was an error requesting a refund',
        });
      }
    }),
    setLoading(val) {
      self.loading = !!val;
    },
  }));
